import { SetState } from 'zustand';
import QuoteService from '~/services/modules/quotes';
import { CustomerRequestParams, PaymentRequestParams, QuoteRequestParams } from '~/services/modules/quotes/types';
import { Product, PromotionData, Quote, QuoteCard, QuoteResponse, QuoteStore } from './types';
const localQuote = QuoteService.localQuote();

const createQuoteSlice = (set: SetState<QuoteStore>) => ({
  contractResponse: localQuote?.contractResponse || null,
  quote: {
    equipment: 'false',
    zipcode: '',
    city: '',
    state: '',
    neighborhood: '',
    street: '',
    number: '',
    name: '',
    email: '',
    phoneNumber: '',
    cpf: '',
    customer_id: '',
    gender: '',
    birthDate: '',
    isSocialName: false,
    equipmentValue: 0,
    yearOfManufacture: 0,
    accessoriesValue: 0,
    hasInvoice: null,
    isNewEquipment: null,
    equipmentMaterial: 1,
    equipmentCondition: 1,
    participatesInCompetitions: false,
    internationalCoverage: false,
    placeStore: 1,
    continents: 1,
    isValideZipcode: false,
    stepChat: 1,
    plan_id: import.meta.env.VITE_ARIDE_DEFAULT_PLAN,
    distributor_id: null,
    organization_id: null,
    seller: null
  },
  customer: {
    name: '',
    email: '',
    mobile_phone: '',
    document: '',
    document_type: '',
    birthdate: ''
  },
  quoteResponse: (undefined as unknown) as QuoteResponse,
  quotes: (localQuote?.quotes as Quote[]) || [],
  products: [] as Product[],
  insured_item: [],
  error: null,
  totalValue: 0,
  serviceCharge: 0,
  promotionData: {} as PromotionData,
  insured: {
    name: '',
    document: '',
    email: '',
    mobile_phone: '',
    birthdate: ''
  },
  quoteCard: {
    membership_fee: {
      number: '',
      cvv: '',
      expiry: '',
      name: '',
      zipcode: '',
      state: '',
      city: '',
      neighborhood: '',
      street: '',
      numberAddress: '',
      additionalDetails: ''
    },
    installments: {
      number: '',
      cvv: '',
      expiry: '',
      name: '',
      zipcode: '',
      state: '',
      city: '',
      neighborhood: '',
      street: '',
      numberAddress: '',
      additionalDetails: ''
    }
  } as QuoteCard,
  setTotalValue: (totalValue: number) => {
    set({ totalValue });
  },
  setProducts: (products: Product[]) => {
    set({ products });
  },
  setServiceCharge: (serviceCharge: number) => {
    set({ serviceCharge });
  },
  setEquipment: (equipment: string) => {
    set((state) => ({ quote: { ...state.quote, equipment } }));
  },
  setZipcode: (zipcode: string) => {
    set((state) => ({ quote: { ...state.quote, zipcode } }));
  },
  setState: (newState: string) => {
    set((state) => ({ quote: { ...state.quote, state: newState } }));
  },
  setCity: (city: string) => {
    set((state) => ({ quote: { ...state.quote, city } }));
  },
  setNeighborhood: (neighborhood: string) => {
    set((state) => ({ quote: { ...state.quote, neighborhood } }));
  },
  setStreet: (street: string) => {
    set((state) => ({ quote: { ...state.quote, street } }));
  },
  setNumber: (number: string) => {
    set((state) => ({ quote: { ...state.quote, number } }));
  },
  setAdditionalDetails: (additionalDetails: string) => {
    set((state) => ({ quote: { ...state.quote, additionalDetails } }));
  },
  SetName: (name: string) => {
    set((state) => ({ quote: { ...state.quote, name } }));
  },
  SetPhoneNumber: (phoneNumber: string) => {
    set((state) => ({ quote: { ...state.quote, phoneNumber } }));
  },
  SetCpf: (cpf: string) => {
    set((state) => ({ quote: { ...state.quote, cpf } }));
  },
  setGender: (gender: 'm' | 'f') => {
    set((state) => ({ quote: { ...state.quote, gender } }));
  },
  SetBirthDate: (birthDate: string) => {
    set((state) => ({ quote: { ...state.quote, birthDate } }));
  },
  setIsSocialName: (isSocialName: boolean) => {
    set((state) => ({ quote: { ...state.quote, isSocialName } }));
  },
  SetEmail: (email: string) => {
    set((state) => ({ quote: { ...state.quote, email } }));
  },
  SetCustomerId: (customer_id: string) => {
    set((state) => ({ quote: { ...state.quote, customer_id } }));
  },
  setStepChat: (step: number) => {
    set((state) => ({
      quote: { ...state.quote, stepChat: step }
    }));
  },
  setEquipmentValue: (equipmentValue: number) => {
    set((state) => ({ quote: { ...state.quote, equipmentValue } }));
  },
  setYearOfManufacture: (yearOfManufacture: number) => {
    set((state) => ({ quote: { ...state.quote, yearOfManufacture } }));
  },
  setAccessoriesValue: (accessoriesValue: number) => {
    set((state) => ({ quote: { ...state.quote, accessoriesValue } }));
  },
  setHasInvoice: (hasInvoice: boolean) => {
    set((state) => ({ quote: { ...state.quote, hasInvoice } }));
  },
  setIsNewEquipment: (isNewEquipment: boolean) => {
    set((state) => ({ quote: { ...state.quote, isNewEquipment } }));
  },
  setEquipmentMaterial: (equipmentMaterial: number) => {
    set((state) => ({ quote: { ...state.quote, equipmentMaterial } }));
  },
  setEquipmentConditions: (equipmentCondition: number) => {
    set((state) => ({ quote: { ...state.quote, equipmentCondition } }));
  },
  setParticipatesInCompetitions: (participatesInCompetitions: boolean) => {
    set((state) => ({ quote: { ...state.quote, participatesInCompetitions } }));
  },
  setInternationalCoverage: (internationalCoverage: boolean) => {
    set((state) => ({ quote: { ...state.quote, internationalCoverage } }));
  },
  setPlaceStore: (placeStore: number) => {
    set((state) => ({ quote: { ...state.quote, placeStore } }));
  },
  setContinents: (continents: number) => {
    set((state) => ({ quote: { ...state.quote, continents } }));
  },
  setIsValideZipcode: (isValid: boolean) => {
    set((state) => ({ quote: { ...state.quote, isValideZipcode: isValid } }));
  },
  setDistributorId: (distributorId: string | null) => {
    set((state) => ({ quote: { ...state.quote, distributor_id: distributorId } }));
  },
  setOrganizationId: (organizationId: string | null) => {
    set((state) => ({ quote: { ...state.quote, organization_id: organizationId } }));
  },
  setSeller: (sellerId: string | null) => {
    set((state) => ({ quote: { ...state.quote, seller: sellerId } }));
  },
  setMembershipFeeCard: (cardData: QuoteCard['membership_fee']) => {
    set((state) => ({
      ...state, // Garante que o restante do estado seja mantido
      quoteCard: {
        ...state.quoteCard,
        membership_fee: cardData
      }
    }));
  },
  setInstallmentsCard: (cardData: QuoteCard['installments']) => {
    set((state) => ({
      ...state, // Garante que o restante do estado seja mantido
      quoteCard: {
        ...state.quoteCard,
        installments: cardData
      }
    }));
  },
  quoteAsyncPost: async (payload: QuoteRequestParams, callback?: () => void) => {
    console.log('payload', payload);
    const quote = await QuoteService.postQuote(payload);
    const { quotes, ...rest } = quote;
    console.log('quote', quote);
    set({ quoteResponse: rest, quotes });
    callback && callback();
  },
  quoteAsyncUpdate: async (quoteHash: string, quoteProducts: Product[], organization_id?: string | null) => {
    const payload = {
      products: quoteProducts.map((p) => ({ product_id: p.product_id })),
      ...(organization_id != null && organization_id !== '' && { organization_id })
    };
    console.log('📦 Payload para PUT /Quotes:', payload);
    const response = await QuoteService.updateQuote(quoteHash, payload);
    set({ products: quoteProducts });
    return response;
    // } catch (error) {
    //   // set({ quote: null })
    // }
  },
  quoteAsyncPostCustomer: async (quoteId: string, customer: CustomerRequestParams) => {
    // try {
    await QuoteService.postQuoteCustomer(quoteId, customer).then(() => {
      set({ customer });
    });
    // } catch (error) {
    //   // set({ quote: null })
    // }
  },
  quoteAsyncPostPayment: async (payment: PaymentRequestParams) => {
    const response = await QuoteService.postQuotePayment(payment);
    set((state) => ({ ...state, contractResponse: response }));
  },
  setPromotionData: (promotionData: PromotionData) => {
    set((state) => ({
      ...state,
      promotionData
    }));
  }
});

export default createQuoteSlice;
